import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { portFolioActions } from "../actions";
import api from "../services/portfolio.service";
import { generalActions } from "../actions";
import ACTIONS from "../constants";
import { portfolioPagination } from "../selectors/portfolio.selector";

function* getPortFolio(state) {
  try {
    yield put(portFolioActions.getPortfolioAttempt.pending);
    const portfolio = yield call(api.portfolioRequest, state.payload);
    const pagination = JSON.parse(portfolio.headers["x-pagination"]);
    const data = {
      data: portfolio.data,
      pagination: pagination,
    };
    yield put(portFolioActions.getPortfolioAttempt.success(data));
  } catch (error) {
    yield put(portFolioActions.getPortfolioAttempt.error(error.message));
  }
}

function* getPortFolioDetails(state) {
  try {
    yield put(portFolioActions.getPortFolioDetailsAttempt.pending);
    const portfolio = yield call(api.getPortfolioDetails, state.payload);
    yield put(portFolioActions.getPortFolioDetailsAttempt.success(portfolio));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(portFolioActions.getPortFolioDetailsAttempt.error(""));
    } else {
      yield put(
        portFolioActions.getPortFolioDetailsAttempt.error(error.message)
      );
    }
  }
}

// portfolio budget summary
function* getPortfolioBudgetSummary(state) {
  try {
    yield put(portFolioActions.getPortFolioBudgetSummaryAttempt.pending);
    const budgetSummary = yield call( api.getPortfolioBudgetSummaryRequest, state.payload);
    yield put(portFolioActions.getPortFolioBudgetSummaryAttempt.success(budgetSummary));
  } catch (error) {
    yield put(portFolioActions.getPortFolioBudgetSummaryAttempt.error(error.message));
  }
}
// portFolio progress summary
function* getPortfolioProgressSummary(state) {
  try {
    yield put(portFolioActions.getPortFolioProgressSummaryAttempt.pending);
    const progressSummary = yield call( api.getPortfolioProgressSummaryRequest, state.payload);
    yield put(portFolioActions.getPortFolioProgressSummaryAttempt.success(progressSummary));
  } catch (error) {
    yield put(portFolioActions.getPortFolioProgressSummaryAttempt.error(error.message));
  }
}

function* createPortfolio(state) {
  try {
    yield put(portFolioActions.createPortfolioAttempt.pending);
    yield call(api.createPortfolioRequest, state.payload);
    // const paginat = yield select(portfolioPagination);
    //  const payload = {id: state.payload.parentID, parent: state.payload.parent, page: paginat.CurrentPage, size: paginat.PageSize}
    const payload = { page: 1, size: state.payload.perPageItems };

    if (state.payload.clientId){
        payload.parent = "Client";
        payload.id = state.payload.clientId;
    }

    const portfolio = yield call(api.portfolioRequest, payload);
    const pagination = JSON.parse(portfolio.headers["x-pagination"]);
    const data = {
      data: portfolio.data,
      pagination: pagination,
    };
    yield put(portFolioActions.createPortfolioAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Portfolio created successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        portFolioActions.createPortfolioAttempt.error(errorObject.data)
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }

    if (errorObject.status === 422) {
      yield put(
        portFolioActions.createPortfolioAttempt.error(errorObject.data)
      );
    }
    if (errorObject.status === 400) {
      yield put(
        portFolioActions.createPortfolioAttempt.error(errorObject.data)
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* updatePortFolio(state) {
  try {
    yield put(portFolioActions.updatePortfolioAttempt.pending);
    yield call(api.updatePortfolioRequest, {
      id: state.payload.id,
      payload: state.payload.payload,
    });
    const paginat = yield select(portfolioPagination);
    let portfolios;
 
    if (state.payload.type === "overview") {
      portfolios = yield call(api.getPortfolioDetails, state.payload);
      const data = {
        type: state.payload.type,
        data: portfolios,
      };
      yield put(portFolioActions.updatePortfolioAttempt.success(data));
    } else {
      const payload = { page: paginat.CurrentPage, size: paginat.PageSize };
      if (state.payload.clientId){
        payload.parent = "Client";
        payload.id = state.payload.clientId;
      }
      portfolios = yield call(api.portfolioRequest, payload);
      const pagination = JSON.parse(portfolios.headers["x-pagination"]);
      const data = {
        data: portfolios.data,
        pagination: pagination,
      };
      yield put(portFolioActions.updatePortfolioAttempt.success(data));
    }
    yield put(
      generalActions.showToast({
        title: "Portfolio updated",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        portFolioActions.updatePortfolioAttempt.error(errorObject.data)
      );
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(
        portFolioActions.updatePortfolioAttempt.error(errorObject.data)
      );
    }
    if (errorObject.status === 400) {
      yield put(
        portFolioActions.updatePortfolioAttempt.error(errorObject.data)
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* sortPortfolios(state) {
  try {
    yield put(portFolioActions.sortPortfoliosAttempt.pending);
    const portfolios = yield call(api.sortPortfoliosRequest, state.payload);
    const pagination = JSON.parse(portfolios.headers["x-pagination"]);
    const data = {
      data: portfolios.data,
      pagination: pagination,
    };
    yield put(portFolioActions.sortPortfoliosAttempt.success(data));
  } catch (error) {
    yield put(portFolioActions.sortPortfoliosAttempt.error(error));
  }
}

function* deletePortfolio(state) {
  try {
    yield put(portFolioActions.deletePortfolioAttempt.pending);
    yield call(api.deletePortfolioRequest, state.payload);
    const paginat = yield select(portfolioPagination);
    const payload = { page: paginat.CurrentPage, size: paginat.PageSize };

    if (state.payload.clientId){
      payload.parent = "Client";
      payload.id = state.payload.clientId;
  }
    const portfolios = yield call(api.portfolioRequest, payload);
    const pagination = JSON.parse(portfolios.headers["x-pagination"]);
    const data = {
      data: portfolios.data,
      pagination: pagination,
    };
    yield put(portFolioActions.deletePortfolioAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Portfolio deleted successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(portFolioActions.deletePortfolioAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(portFolioActions.deletePortfolioAttempt.error(error));
    }
    if (errorObject.status === 400) {
      yield put(portFolioActions.deletePortfolioAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: `${error}`,
          type: "Error",
        })
      );
    }
  }
}

function* updatePortfolioFlag(state) {
  try {
    yield put(portFolioActions.updatePortfolioFlagAttempt.pending);
    yield call(api.updatePortfolioFlagRequest, state.payload);
    yield put(portFolioActions.updatePortfolioFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Portfolio flag update successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(portFolioActions.updatePortfolioFlagAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(portFolioActions.updatePortfolioFlagAttempt.error(error));
    }
    if (errorObject.status === 400) {
      yield put(portFolioActions.updatePortfolioFlagAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: `${error}`,
          type: "Error",
        })
      );
    }
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.PORTFOLIO_CALL, getPortFolio),
    takeEvery(ACTIONS.CREATE_PORTFOLIO_CALL, createPortfolio),
    takeEvery(ACTIONS.UPDATE_PORTFOLIO_CALL, updatePortFolio),
    takeEvery(ACTIONS.GET_PORTFOLIO_DETAILS_CALL, getPortFolioDetails),
    takeEvery(ACTIONS.SORT_PORTFOLIOS_CALL, sortPortfolios),
    takeEvery(ACTIONS.DELETE_PORTFOLIOS_CALL, deletePortfolio),
    takeEvery(ACTIONS.PORTFOLIO_FLAG_CALL, updatePortfolioFlag),
    takeEvery(ACTIONS.GET_PORTFOLIO_BUDGET_SUMMARY_CALL, getPortfolioBudgetSummary),
    takeEvery(ACTIONS.GET_PORTFOLIO_PROGRESS_SUMMARY_CALL, getPortfolioProgressSummary),
  ]);
}
